export default __webpack_public_path__ + "static/media/top_section_logo.98713e5c.png";